import { render, staticRenderFns } from "./OnlineMessage.vue?vue&type=template&id=f3bde960&scoped=true"
import script from "./OnlineMessage.vue?vue&type=script&lang=js"
export * from "./OnlineMessage.vue?vue&type=script&lang=js"
import style0 from "./OnlineMessage.vue?vue&type=style&index=0&id=f3bde960&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bde960",
  null
  
)

export default component.exports